import {
  IframeLoader,
  Modal,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalManager,
} from "../../../../components";
import React from "react";
import { LivenessModalFooter } from "./Liveness.footer";
import { useOneKycEventListener } from "./hooks";
import { useTranslation } from "../../../../hooks";

type Props = {
  show: boolean;
  onClose: () => any;
  src: string;
  onResult: (data: any) => void;
};

export const CameraIFrameModal = ({ onClose, show, src, onResult }: Props) => {
  useOneKycEventListener(onResult);

  return (
    <ModalManager scrollable fullScreen onClose={onClose} showModal={show}>
      <Modal>
        <ModalHeader />
        <ModalContent>
          <IframeLoader
            src={src}
            id="oneKYCIframe"
            sandbox="allow-same-origin allow-scripts"
            allow="camera"
          />
        </ModalContent>
      </Modal>
    </ModalManager>
  );
};

export const QRIFrameModal = ({
  onClose,
  show,
  src,
  onUseCamera,
  onResult,
}: Props & { onUseCamera: () => void }) => {
  const translate = useTranslation();
  useOneKycEventListener(onResult);

  return (
    <ModalManager scrollable fullScreen onClose={onClose} showModal={show}>
      <Modal maxHeight="800px" maxWidth="1200px">
        <ModalHeader />
        <ModalContent>
          <IframeLoader
            src={src}
            id="oneKYCIframe"
            sandbox="allow-same-origin allow-scripts"
          />
        </ModalContent>
        <ModalFooter>
          <LivenessModalFooter
            description={translate(
              "owner_info.liveness.qr_iframe_modal.description"
            )}
            buttonText={translate("owner_info.liveness.qr_iframe_modal.cta")}
            onButtonClick={onUseCamera}
          />
        </ModalFooter>
      </Modal>
    </ModalManager>
  );
};
